import { render, staticRenderFns } from "./Profitability.vue?vue&type=template&id=1994fcca&"
import script from "./Profitability.vue?vue&type=script&lang=js&"
export * from "./Profitability.vue?vue&type=script&lang=js&"
import style0 from "./Profitability.vue?vue&type=style&index=0&id=1994fcca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports